import React from "react";
import Slider from "react-slick";
const defaultImage = require('../media/sancoIcon_trans.png');

const winners = 
  [ 
    {
      boatName: "Chinito Bonito",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2FChinito.jpg?alt=media&token=8497cb3a-c273-473f-8fc0-d490e4d0fa35",
      id: "-LQLjF8i-2l2kMsyFgyF",
      lastFishTime: "2018-11-04T15:38:50.648Z",
      lastTime: 1541261741,
      total: 243,
      rank: 1
    },
    {
      boatName: "Chinito Bonito",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2FChinito.jpg?alt=media&token=8497cb3a-c273-473f-8fc0-d490e4d0fa35",
      id: "-LQLjF8i-2l2kMsyFgye",
      lastFishTime: "2018-11-04T15:38:50.648Z",
      lastTime: 1541261741,
      total: 218,
      rank: 2
    },
    {
      boatName: "Cloud Nine",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2Fa22.jpg?alt=media&token=a260aa86-2077-4292-a492-0d3b03616fa6",
      id: "-LQPvaMqTRywOErspCSO",
      lastFishTime: "2018-11-04T20:34:25.815Z",
      lastTime: 1541363666,
      total: 185,
      rank: 3
    },
    {
      boatName: "Knot Workin",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2FKnotWorkin!.jpg?alt=media&token=54c079fe-b643-4f53-a342-4f795e8e0b37",
      id: "-LQLkwwznZRmUHX4cUR7",
      lastFishTime: "2018-11-04T14:57:35.040Z",
      lastTime: 1541282284,
      total: 91.4,
      rank: 4
    },
    {
      boatName: "Reyna De Wahoo",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2Fa9.jpg?alt=media&token=5f8de0e9-75f3-4639-b372-557ffea92487",
      id: "-LQLdEoDUsjpo9JxOByV",
      lastFishTime: "2018-11-04T18:03:06.194Z",
      lastTime: 1541281363,
      total: 79.6,
      rank: 5
    },
    {
      boatName: "Sneak Attack",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2FSneakAttack.jpg?alt=media&token=0a7de3fc-6232-4eae-b40b-5286561c7333",
      id: "-LQQufkDjX3IgHV3tfKa",
      lastFishTime: "2018-11-03T23:56:15.567Z",
      lastTime: 1541289376,
      total: 54.6,
      rank: 6
    },
    {
      boatName: "Ranchero",
      boatThm: "https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/profileImages%2FRanchero.jpg?alt=media&token=f661d879-fd78-4dfc-b2fe-f66bf7471db2",
      id: "-LQLVrks0YSc43D8qaja",
      lastFishTime: "2018-11-04T21:20:51.277Z",
      lastTime: 1541366451,
      total: 49.3,
      rank: 7
    }
  ]

export class SpeciesWinnersSingle extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      boatScores: [],
      logs: this.props.logs,
      speciesId: this.props.speciesId,
      speciesName: this.props.speciesName,
      boatRanks: []
    }
  }
  
  componentDidMount() {
    this.getSpeciesPoints();
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, speciesId: newProps.speciesId, speciesName: newProps.speciesName});
    this.getSpeciesPoints(newProps.speciesId);
  }

  getSpeciesPoints(speciesId) {
    var boatTotals = [];
    var allFish = [];
    var logs = this.state.logs;
    logs.forEach((boatLog) => {
      var speciesFish = [];
      boatLog.boatCaughtFish.forEach((log) => {
        if(speciesId === log.speciesId) {
          var date = new Date(log.catchDate)
          speciesFish.push(log);
          allFish.push({
            id: log.boatId,
            boatName: log.boatName,
            boatThm: log.boatThm,
            lbs: parseFloat(log.lbs),
            catchDate: date,
            catchDateInt: parseInt(Math.round(date.getTime() / 1000))
          });
        }
      });
      if(speciesFish.length > 0) {
        var sortedFish = this.sortFishLbs(speciesFish);
        var d = new Date(sortedFish.catchDate);
        boatTotals.push({
          id: boatLog.boatId,
          boatName: boatLog.boatName,
          boatThm: boatLog.boatThm,
          total: parseFloat(sortedFish.lbs),
          lastFishTime: boatLog.lastFishTime,
          lastTime: parseInt(Math.round(d.getTime() / 1000))
        })
      }
    })
    var allFishScores = this.sortAllFishLbs(allFish);
    this.setState({
      boatScores: this.scoreSortFilter(boatTotals),
      boatRanks: this.getBoatRanks(allFishScores)
    })
  }
  
  sortFishLbs (fish) {
     Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    fish.sortOn("lbs", fish.catchDate);
    fish.reverse();
    return fish[0];
  }
  
  sortAllFishLbs (fish) {
     Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    fish.sortOn("lbs", "catchDateInt");
    fish.reverse();
    return fish;
  }
  
  getBoatRanks(allFish) {
    var rank = 1;
    var bScores = [];
    allFish.forEach((fish) => {
      bScores.push({
        rank: rank++,
        fish: fish
      })
    })
    return bScores;  
  }

  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    boatScores.sortOn("total", "lastTime");
    boatScores.reverse();
    
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(parseInt(item.total))) {
        return true;
      } 
      return false; 
    }
    
    var boatScoresArray = boatScores.filter(filterByTotal);
    
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
    return bScores;  
  }
  
  render() {
    if (this.state.boatRanks.length > 2){
      var numSlides = 3;
    } else {
      var numSlides = this.state.boatRanks.length;
    }
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: numSlides,
      slidesToScroll: numSlides,
    };
    return (
        <div className="speciesScoresBoxPelagic">
          { this.state.boatRanks.length > 0 ? <Slider {...settings}>
          { this.state.boatRanks.map(boat => (
            <div id='rank-box' className="boatBox" key={boat.fish.id}>
              {boat.fish.boatThm ? 
                <div id='boat-total' 
                  style={{
                    position: 'relative',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 50%',
                    borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
                    borderSize: 4,
                    borderStyle: 'solid',
                    width: '100%', 
                    height: boat.rank === 1 ? 120 : 100, 
                    backgroundImage: 'url(' + boat.fish.boatThm + ')'
                  }}>
                    <div id='boat-rank' style={{height: 25, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 18, backgroundColor: '#ccc', color: '#191970', overflow: 'hidden', textOverflow:'clip'}}>
                      <center>{boat.fish.boatName} </center>
                    </div>
                    <div id='rank'
                      style={{
                        backgroundColor: 'white',
                        width: 30,
                        height: 30,
                        borderRadius: 15,
                        float: 'left',
                        marginLeft: 3,
                        fontWeight: 'bold', 
                        fontSize: 18,
                        opacity: .7,
                      }}> 
                     <center style={{lineHeight: 1.8}}> # {boat.rank}</center>
                    </div>
                    <div id='boat-total' style={{height: 25, width: '80%', float: 'right', fontWeight: 'bold', fontSize: 16, backgroundColor: '#fff', color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute', bottom: 0, right: 0, opacity: .6}}>
                      <center>LBS: {boat.fish.lbs ? boat.fish.lbs : 'NA'}</center>
                    </div>
                  </div> :
                <div id='boat-total' 
                  style={{
                    position: 'relative',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#ccc',
                    backgroundPosition: '50% 50%',
                    borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
                    borderSize: 4,
                    borderStyle: 'solid',
                    width: '100%', 
                    height: boat.rank === 1 ? 120 : 100, 
                    backgroundImage: 'url(' + defaultImage + ')'
                  }}>
                    <div id='boat-rank' style={{height: 25, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 18, backgroundColor: '#ccc', color: '#191970', overflow: 'hidden', textOverflow:'clip'}}>
                      <center>{boat.fish.boatName} </center>
                    </div>
                    <div id='rank'
                      style={{
                        backgroundColor: 'white',
                        width: 30,
                        height: 30,
                        borderRadius: 15,
                        float: 'left',
                        marginLeft: 3,
                        fontWeight: 'bold', 
                        fontSize: 18,
                        opacity: .7,
                      }}> 
                     <center style={{lineHeight: 1.8}}> # {boat.rank}</center>
                    </div>
                    <div id='boat-total' style={{height: 25, width: '80%', float: 'right', fontWeight: 'bold', fontSize: 16, backgroundColor: '#fff', color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute', bottom: 0, right: 0, opacity: .6}}>
                      <center>LBS: {boat.fish.lbs ? boat.fish.lbs : 'NA'}</center>
                    </div>
                  </div>
                }
            </div>
          ))}
        </Slider>
        
        : <div className="no_fish_text">No {this.state.speciesName} Boated Yet.</div> 
        }
        <div className="division_title">{ this.state.speciesName } Division</div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SpeciesWinnersSingle.js